import { checkValidLength } from "../../utils/utils";
import {
  isNotNull,
  isNullEmpty,
  isNumber,
  isNumberOrNull,
} from "../../utils/validation";
import SALES_RECORD_TYPE from "../../utils/variable";

const fieldTranslations = {
  salesRecordNo: "原票No",
  salesRecordTypeCd: "原票種別",
  arrivalDate: "入荷日付",
  fkey: "FKey",
  productId: "商品ID",
  commodityOwnerCd: "荷主コード",
  acceptanceEmployeeId: "受け取りID",
  seriEmployeeId: "セリ人",
  acceptanceLabelNo: "送り状No",
  partition: "仕切",
  originId: "産地",
  commodityMark: "荷印",
  directorEmployeeId: "担当",
  containerQuantity: "コンテナ数",
  director: "札番",
  feeRate: "手数料率",
  shippingFee: "運賃",
  depositFee: "預り金金額",
  salesRecordProcessDivisionCd: "原票処理区分コード",
  salesDetailNo: "販売明細ID",
  rankId: "等級ID",
  productClassId: "階級ID",
  packingId: "荷姿ID",
  weight: "重量（g）",
  quantity: "数量",
  purchacePrice: "仕入値",
  unitPrice: "単価",
  buyerNo: "買人No",
  containerShippingId: "コンテナ入出庫ID",
  // Add any other fields and their translations as needed
};

const salesRecordValidationRules = {
  salesRecordNo: [isNumber, isNotNull],
  salesRecordTypeCd: [isNumber],
  arrivalDate: [isNotNull],
  fkey: [isNumberOrNull],
  productId: [isNumber],
  commodityOwnerCd: [isNumber],
  acceptanceEmployeeId: [isNumberOrNull],
  seriEmployeeId: [isNumberOrNull],
  acceptanceLabelNo: [isNumberOrNull],
  partition: [isNumberOrNull],
  originId: [isNumber],
  commodityMark: [isNumberOrNull],
  directorEmployeeId: [isNumberOrNull],
  containerQuantity: [isNumberOrNull],
  director: [isNumberOrNull],
  feeRate: [isNumber],
  shippingFee: [isNumber],
  depositFee: [isNumber],
  salesRecordProcessDivisionCd: [isNumber],
  // status: [isNumber],
  //   modificationDate: "",
  //   createdAt: new Date().toISOString(),
};

const salesDetailValidationRules = {
  salesDetailNo: [isNumber],
  rankId: [isNumberOrNull],
  productClassId: [isNumberOrNull],
  packingId: [isNumberOrNull],
  weight: [isNumberOrNull],
  quantity: [isNumber],
  purchacePrice: [isNumber],
};

const salesResultsValidationRules = {
  salesDetailNo: [isNumber],
  unitPrice: [isNumber],
  buyerNo: [isNumber],
  quantity: [isNumber],
  containerShippingId: [isNumberOrNull],
  containerQuantity: [isNumber],
  price: [isNumberOrNull],
};

export default function validateSalesRecord(salesRecord) {
  let errors = [];

  for (const key in salesRecordValidationRules) {
    const fieldRules = salesRecordValidationRules[key];
    fieldRules.forEach((rule) => {
      if (!rule(salesRecord.salesRecordInfo[key])) {
        // errors.push(`Invalid value for field: ${key} (failed ${rule} check)`);
        const translatedFieldName = fieldTranslations[key] || key; // fallback to the English name if translation is missing
        errors.push(`${translatedFieldName}の値が無効です。`);
      }
    });
  }

  salesRecord.listSalesDetailInfo
    .filter((salesDetail) => !salesDetail.isRemove)
    .forEach((salesDetail) => {
      //新規販売明細は数量必須
      if (salesDetail.isNew && isNullEmpty(salesDetail.quantity))
        errors.push("販売明細の数量が無効です。");
      for (const key in salesDetailValidationRules) {
        const fieldRules = salesDetailValidationRules[key];
        fieldRules.forEach((rule) => {
          if (!rule(salesDetail[key])) {
            // errors.push(`Invalid value for field: ${key} (failed ${rule} check)`);
            const translatedFieldName = fieldTranslations[key] || key; // fallback to the English name if translation is missing
            errors.push(`${translatedFieldName}の値が無効です。`);
          }
        });
      }
    });

  salesRecord.listSalesResultsInfo
    .filter((salesResults) => !salesResults.isRemove)
    .forEach((salesResults) => {
      for (const key in salesResultsValidationRules) {
        const fieldRules = salesResultsValidationRules[key];
        fieldRules.forEach((rule) => {
          if (!rule(salesResults[key])) {
            // errors.push(`Invalid value for field: ${key} (failed ${rule} check)`);
            const translatedFieldName = fieldTranslations[key] || key; // fallback to the English name if translation is missing
            errors.push(`${translatedFieldName}の値が無効です。`);
          }
        });
      }
    });

  //備考チェック
  salesRecord.listSalesResultsInfo
    .filter((salesResults) => !salesResults.isRemove)
    .forEach((salesResults) => {
      if (!checkValidLength(salesResults.remarks, 10))
        errors.push(`備考の長さを確認してください。`);
    });

  //明細・実績関係チェック

  if (
    salesRecord.salesRecordInfo.salesRecordTypeCd === SALES_RECORD_TYPE.TRAVEL
  ) {
    const checkQuantityResults = checkQuantity(salesRecord);
    const checkPurchacePriceResults = checkPurchacePrice(salesRecord);
    errors = errors
      .concat(checkQuantityResults)
      .concat(checkPurchacePriceResults);
  }

  if (
    salesRecord.salesRecordInfo.salesRecordTypeCd === SALES_RECORD_TYPE.LOCAL
  ) {
    const checkQuantityResults = checkQuantityLocalInvoice(salesRecord);
    errors = errors.concat(checkQuantityResults);
  }

  //ユニークエラー一覧を返す
  return Array.from(new Set(errors));
}

function checkQuantity(salesRecord) {
  const errors = [];
  const salesDetailNos = salesRecord.listSalesDetailInfo.map(
    (salesDetail) => salesDetail.salesDetailNo
  );

  const salesDetailQuantityMap = {};

  salesRecord.listSalesResultsInfo
    .filter((salesResults) => !salesResults.isRemove)
    .forEach((salesResult) => {
      if (!salesDetailNos.includes(parseInt(salesResult.salesDetailNo))) {
        errors.push(
          `無効な販売実績：販売明細No「${salesResult.salesDetailNo}」は存在しません。`
        );
      } else {
        salesDetailQuantityMap[salesResult.salesDetailNo] =
          (salesDetailQuantityMap[salesResult.salesDetailNo] || 0) +
          parseInt(salesResult.quantity);
      }
    });

  for (const salesDetailNo in salesDetailQuantityMap) {
    const correspondingSalesDetail = salesRecord.listSalesDetailInfo.find(
      (detail) => detail.salesDetailNo == salesDetailNo
    );

    if (
      correspondingSalesDetail &&
      salesDetailQuantityMap[salesDetailNo] > correspondingSalesDetail.quantity
    ) {
      errors.push(
        `無効な販売実績：明細No「${salesDetailNo}」の販売実績の数量合計が、在庫の数量合計を超えています。`
      );
    }
  }
  return errors;
}

function checkQuantityLocalInvoice(salesRecord) {
  const errors = [];
  const salesDetailNos = salesRecord.listSalesDetailInfo.map(
    (salesDetail) => salesDetail.salesDetailNo
  );

  const salesDetailQuantityMap = {};

  salesRecord.listSalesResultsInfo
    .filter((salesResults) => !salesResults.isRemove)
    .forEach((salesResult) => {
      if (!salesDetailNos.includes(parseInt(salesResult.salesDetailNo))) {
        errors.push(
          `無効な販売実績：販売明細No「${salesResult.salesDetailNo}」は存在しません。`
        );
      } else {
        salesDetailQuantityMap[salesResult.salesDetailNo] =
          (salesDetailQuantityMap[salesResult.salesDetailNo] || 0) +
          parseInt(salesResult.quantity);
      }
    });

  for (const salesDetailNo in salesDetailQuantityMap) {
    const correspondingSalesDetail = salesRecord.listSalesDetailInfo.find(
      (detail) => detail.salesDetailNo == salesDetailNo
    );

    if (
      correspondingSalesDetail &&
      salesDetailQuantityMap[salesDetailNo] != correspondingSalesDetail.quantity
    ) {
      errors.push(
        `無効な販売実績：明細No「${salesDetailNo}」の販売実績の数量合計が、在庫の数量合計と合わない。`
      );
    }
  }
  return errors;
}

function checkPurchacePrice(salesRecord) {
  const errors = [];
  salesRecord.listSalesResultsInfo
    .filter((salesResults) => !salesResults.isRemove)
    .forEach((salesResult) => {
      const correspondingSalesDetail = salesRecord.listSalesDetailInfo.find(
        (detail) => detail.salesDetailNo == salesResult.salesDetailNo
      );

      if (
        correspondingSalesDetail &&
        (correspondingSalesDetail.purchacePrice === 0 ||
          correspondingSalesDetail.purchacePrice === "")
      ) {
        errors.push(
          `無効な販売明細：明細No「${salesResult.salesDetailNo}」の仕入値が無効です。`
        );
      }
    });
  return errors;
}
